import { useNavigate } from 'react-router';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { PATH_PAGE, QUERY_KEY } from '../../../constant';
import { useContext, useEffect, useMemo, useState, Fragment } from 'react';
import { get } from 'lodash';
import { HeaderCommon } from '../../../components/header';
import { CalendarBackIcon, ComingSoonIcon } from '../../../assets/images';
import Scrollbars from 'react-custom-scrollbars';
import { getIconCategory } from '../../../utils/getIconCategory';
import { ButtonGradient } from '../../../components/common/button/ButtonGradient';
import { getDetailSim, sendLockSim } from '../../../services/product';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { sendBookingSim } from '../../../services/booking';
import AuthContext from '../../../context/AuthProvider';
import { SpinCustom } from '../../../components/common/SpinCustom';
import { AccountAuthen } from '../../../components/common/AccountAuthen';
import useCheckDeviceMobi from 'hooks/useCheckDeviceMobi';
import { getIconSupplier } from 'utils/getIconSupplier';
import { Dialog, Transition } from '@headlessui/react';
import { numbersWithDots, redirectDownload } from 'utils/utils';

interface SimDetail {
  dwType: number;
  dwTypeName: string;
  groupId: number;
  groupName: string;
  link: string;
  minPrice: number;
  msisdn: string;
  priceTemp?: number;
  roamingFee: number;
  shareValue: number;
  simStore?: string;
  simTerm?: string;
  status: number;
  statusStr: string;
  supplier: number;
  supplierStr: string;
  type: number;
  typeStr: string;
}


export const InfoSim = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { userLogin } = useContext(AuthContext);
  const isMobile = useCheckDeviceMobi();
  const [isShowNotification, setIsShowNotification] = useState<boolean>(false);
  const [showDialog, setShowDialog] = useState<boolean>(false);


  // lấy tạm data từ table 
  const location = useLocation();
  const simDetail = location.state as SimDetail;

  console.log('location: ' + location.state);

  const { data, isLoading, remove } = useQuery(QUERY_KEY.SIM_DETAIL, () => getDetailSim({ msisdn: id }), {
    enabled: !!id,
  });

  const mutationLockSim = useMutation((param: any) => sendLockSim(param), {
    onSuccess: (response: AxiosResponse<any>) => {
      if (response.data.data.data) {
        mutationSendBooking.mutate({
          msisdn: get(infoData, 'msisdn'),
          custName: userLogin.fullName,
          custPhone: userLogin.mobile,
          ssid: response.data.data.data.ssid,
          addrCityId: userLogin.provinceId,
          addrDistId: userLogin.districtId,
          addrCurr: userLogin.address,
          typeSource: 'CTV',
          addrWardId: 0,
          custEmail: userLogin.email,
          idNo: userLogin.passportId,
          userType: 'MEM',
        });
      } else {
        toast.error('Số thuê bao đang ở 1 giao dịch giữ số khác. Vui lòng chọn số khác hoặc thử lại sau');
      }
    },
  });

  const mutationSendBooking = useMutation((param: any) => sendBookingSim(param), {
    onSuccess: (response: AxiosResponse<any>) => {
      if (response.data.data.data) {
        toast.success('Giữ số thành công!');
        navigate(`${PATH_PAGE.STATISTIC_TRANSACTION}/info/${response.data.data.transCode}`);
      } else {
        toast.error('Số thuê bao đang ở 1 giao dịch giữ số khác. Vui lòng chọn số khác hoặc thử lại sau');
      }
    },
  });

  const infoData = useMemo(() => {
    return get(data, 'data.data.data.items[0]', {});
  }, [data]);

  useEffect(() => {
    return () => remove();
  }, []);

  return (
    <div className={'h-full w-full rounded-[20px] bg-[#F8F8F8] p-6 !pr-0'}>
      <HeaderCommon
        children={
          <div className={'flex flex-row items-center space-x-2'}>
            <span className={'mr-[8px] cursor-pointer'} onClick={() => navigate(-1)}>
              <img className="h-[18px] w-[18px]" src={CalendarBackIcon} alt="Logo" />
            </span>
            <span className={'text-[22px] font-extrabold text-[#404040]'}>Thông tin sản phẩm</span>
          </div>
        }
      />
      <div className={'relative mt-10 h-[calc(100%-90px)] w-full md:mt-0'}>
        {isMobile ? (
          <div className={'mr-7'}>
            <div
              className={
                'mb-2 flex cursor-pointer flex-row space-x-2 text-[12px] font-medium leading-[16px] text-[#71717A]' +
                ' md:hidden'
              }
            >
              <NavLink to={PATH_PAGE.DASHBOARD}>Trang chủ</NavLink>
              <span>|</span>
              <span>Sản phẩm</span>
              <span>|</span>
              <span>Sim số</span>
            </div>
            <div className="mb-4 flex flex-row items-center space-x-2">
              <div onClick={() => navigate(-1)}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.54637 8.40283L9.33137 13.1888C9.52498 13.3824 9.78757 13.4912 10.0614 13.4912C10.3352 13.4912 10.5978 13.3824 10.7914 13.1888C10.985 12.9952 11.0938 12.7326 11.0938 12.4588C11.0938 12.185 10.985 11.9224 10.7914 11.7288L6.72637 7.66583L10.7914 3.60384C10.9848 3.41023 11.0935 3.14769 11.0934 2.87398C11.0934 2.73845 11.0666 2.60426 11.0147 2.47907C10.9628 2.35388 10.8867 2.24014 10.7909 2.14434C10.695 2.04854 10.5812 1.97256 10.456 1.92074C10.3308 1.86891 10.1965 1.84227 10.061 1.84231C9.78731 1.84241 9.52485 1.95123 9.33137 2.14484L4.54637 6.92983C4.35115 7.12522 4.24148 7.39013 4.24148 7.66633C4.24148 7.94254 4.35115 8.20745 4.54637 8.40283Z"
                    fill="#6A6A6A"
                  />
                </svg>
              </div>
              <span className="text-lg font-bold text-baseColor">Thông tin sản phẩm</span>
            </div>
            <div
              className={
                'flex min-h-[116px] w-full flex-col justify-between rounded-t-[16px] rounded-bl-[16px] bg-white' +
                ' px-4 py-2 shadow-base'
              }
            >
              <div className={'grid w-full grid-cols-5 '}>
                <div className={'col-span-3 flex flex-row items-center justify-between space-x-1.5'}>
                  <div className={'min-h-[58px] min-w-[58px]'}>{getIconSupplier(infoData.supplier || simDetail?.supplier)}</div>
                  <div className={'flex w-full flex-col'}>
                    <span className={'text-lg font-bold text-[#404040]'}>{infoData.msisdn || simDetail?.msisdn}</span>
                    <span className={'text-sm font-normal text-[#818181]'}>{infoData.groupName || simDetail?.groupName}</span>
                    <span className={'text-sm font-normal text-[#818181]'}>{infoData.typeStr || simDetail?.typeStr}</span>
                  </div>
                </div>
                <div className={'col-span-2 flex w-full flex-col items-end justify-center'}>
                  <div className={'flex flex-row items-center space-x-0.5 text-base font-bold text-[#F15836]'}>
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.87891 2.89258C7.20831 2.89495 6.56585 3.1624 6.09166 3.63658C5.61747 4.11077 5.35003 4.75323 5.34766 5.42383C5.34766 5.87383 5.47534 6.29177 5.68178 6.65458C4.66872 7.24745 3.87559 8.08895 3.44922 9.08008H3.37891C3.34174 9.08092 3.30479 9.07423 3.27028 9.06039C3.23578 9.04656 3.20444 9.02587 3.17815 8.99959C3.15186 8.9733 3.13118 8.94196 3.11734 8.90745C3.10351 8.87295 3.09681 8.83599 3.09766 8.79883C3.09766 8.69983 3.14828 8.62108 3.22084 8.57045L2.57003 7.65639C2.38573 7.78455 2.23515 7.95537 2.13114 8.1543C2.02712 8.35322 1.97275 8.57435 1.97266 8.79883C1.97266 9.4907 2.48903 10.0577 3.15053 10.1702C3.12184 10.3671 3.09766 10.5634 3.09766 10.7676C3.09766 12.1693 3.84241 13.3843 4.92578 14.2832C4.78966 14.8457 4.85772 15.4453 5.29478 15.883C5.61746 16.2029 6.05344 16.3823 6.50781 16.3823C6.96219 16.3823 7.39817 16.2029 7.72084 15.883L7.93178 15.672C8.37109 15.753 8.81266 15.8301 9.28516 15.8301C9.75766 15.8301 10.1992 15.753 10.6385 15.672L10.8495 15.883C11.1721 16.2029 11.6081 16.3823 12.0625 16.3823C12.5169 16.3823 12.9529 16.2029 13.2755 15.883C13.7036 15.4543 13.7677 14.8721 13.6445 14.3181C14.0956 13.9517 14.4818 13.5121 14.787 13.0176H16.0352V8.51758H14.7521C14.5479 8.18604 14.3059 7.87931 14.031 7.60352L14.3477 5.86314V5.14258H13.7852C13.7852 5.14258 12.434 5.16508 11.2888 6.02177C10.9881 5.93502 10.683 5.86442 10.3747 5.81027C10.3972 5.68539 10.4102 5.55545 10.4102 5.42383C10.4102 4.03277 9.26997 2.89258 7.87891 2.89258ZM7.87891 4.01758C8.66078 4.01758 9.28516 4.64195 9.28516 5.42383C9.28516 5.52058 9.26772 5.61283 9.24972 5.70508C8.34241 5.70958 7.48572 5.88508 6.70159 6.17983C6.55224 5.956 6.47257 5.69292 6.47266 5.42383C6.47266 4.64195 7.09703 4.01758 7.87891 4.01758ZM13.082 6.37333C13.091 6.37108 13.091 6.37502 13.0995 6.37333L12.8885 7.65583L12.8362 7.95508L13.082 8.16602C13.4576 8.49129 13.7678 8.88512 13.9961 9.32645L14.1542 9.64258H14.9102V11.8926H14.1542L13.9961 12.2093C13.7216 12.7515 13.2885 13.2285 12.7305 13.6324L12.326 13.9316L12.5724 14.389C12.7063 14.6151 12.6821 14.8941 12.4841 15.0921C12.4307 15.1477 12.3666 15.192 12.2956 15.2223C12.2247 15.2526 12.1484 15.2682 12.0712 15.2682C11.9941 15.2682 11.9177 15.2526 11.8468 15.2223C11.7758 15.192 11.7117 15.1477 11.6583 15.0921L11.2539 14.6871L11.0255 14.4767L10.7263 14.547C10.2695 14.6522 9.78409 14.7051 9.28516 14.7051C8.80018 14.7068 8.31655 14.6538 7.84347 14.547L7.54534 14.4767L7.31641 14.6876L6.91197 15.0915C6.85857 15.1473 6.79443 15.1916 6.72343 15.222C6.65242 15.2523 6.57602 15.2679 6.49881 15.2679C6.42161 15.2679 6.3452 15.2523 6.2742 15.222C6.20319 15.1916 6.13906 15.1473 6.08566 15.0915C5.99308 15.0019 5.93391 14.8833 5.91795 14.7554C5.90199 14.6275 5.9302 14.498 5.99791 14.3884L6.24428 13.9316L5.83984 13.633C4.82228 12.8938 4.22266 11.8858 4.22266 10.7676C4.22266 8.6627 6.42203 6.83008 9.28516 6.83008C9.97703 6.83008 10.6363 6.93358 11.2365 7.12877L11.5352 7.23452L11.7815 7.02358C12.1832 6.66527 12.6798 6.47233 13.082 6.37333ZM12.6602 9.64258C12.3508 9.64258 12.0977 9.8957 12.0977 10.2051C12.0977 10.5145 12.3508 10.7676 12.6602 10.7676C12.9695 10.7676 13.2227 10.5145 13.2227 10.2051C13.2227 9.8957 12.9695 9.64258 12.6602 9.64258Z"
                        fill="#F15836"
                      />
                    </svg>
                    {`${numbersWithDots(infoData.shareValue ? (+infoData.shareValue).toLocaleString('vi') : simDetail?.shareValue || 0)} VNĐ`}
                  </div>
                  <div className={'flex flex-row items-center space-x-2 text-sm font-normal text-[#818181]'}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.55859 3.51758H3.56234M3.55859 2.01758H5.43359C5.62559 2.01758 5.81759 2.0907 5.96384 2.23733L8.58884 4.86233C8.72945 5.00297 8.80843 5.1937 8.80843 5.39258C8.80843 5.59145 8.72945 5.78218 8.58884 5.92283L5.96384 8.54783C5.8232 8.68843 5.63247 8.76742 5.43359 8.76742C5.23472 8.76742 5.04399 8.68843 4.90334 8.54783L2.27834 5.92283C2.2086 5.85327 2.15328 5.77063 2.11556 5.67963C2.07785 5.58863 2.05849 5.49108 2.05859 5.39258V3.51758C2.05859 3.11975 2.21663 2.73822 2.49793 2.45692C2.77924 2.17561 3.16077 2.01758 3.55859 2.01758Z"
                        stroke="#818181"
                        strokeWidth="0.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {`${numbersWithDots(infoData.roamingFee ? infoData.roamingFee.toLocaleString('vi') : simDetail?.roamingFee || 0)} VNĐ`}
                  </div>
                </div>
              </div>
              <div className={'grid grid-cols-2 gap-2 border-t border-[#EFEFEF] pt-2'}>
                <ButtonGradient
                  className={'h-[32px] w-full !rounded-t-[8px] !rounded-bl-[8px]'}
                  background={'bg-white !rounded-t-[6px] !rounded-bl-[6px]'}
                  onClick={() => {
                    if (userLogin?.statusVerify === 1) {
                      navigator?.clipboard?.writeText(infoData.link);
                      toast.success('Sao chép link thành công!');
                      return;
                    }
                    setIsShowNotification(true);
                  }}
                  // onClick={() => setShowDialog(true)}
                >
                  <span className={'text-xs font-bold leading-[18px] text-[#F15836]'}>Lấy link</span>
                </ButtonGradient>
                <button
                  className={
                    'h-[32px] w-full rounded-t-[8px] rounded-bl-[8px] bg-[#F15836] text-[12px] font-bold text-white' +
                    ' md:hidden'
                  }
                  // onClick={() => {
                  //   if (userLogin?.statusVerify === 1) {
                  //     mutationLockSim.mutate({
                  //       ssid: 0,
                  //       listMsisdn: [get(infoData, 'msisdn')],
                  //     });
                  //     return;
                  //   }
                  //   setIsShowNotification(true);
                  // }}
                  onClick={() => setShowDialog(true)}
                >
                  Giữ số
                </button>
              </div>
            </div>
            {/* <div
              className={
                'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white px-6 py-3'
              }
            >
              <div className={'flex flex-row items-center'}>
                {getIconCategory('SIMSO')}
                <span className={'ml-2 text-base font-bold text-baseColor'}>Số thuê bao {get(infoData, 'msisdn')}</span>
              </div>
              <div className={'space-t-0.5 flex flex-col items-center justify-center md:flex-row md:space-x-2.5'}>
                <ButtonGradient
                  className={'h-[30px] w-[100px]'}
                  background={'bg-white'}
                  onClick={() => {
                    if (userLogin?.statusVerify === 1) {
                      navigator?.clipboard?.writeText(infoData.link);
                      toast.success('Sao chép link thành công!');
                      return;
                    }
                    setIsShowNotification(true);
                  }}
                >
                  <span className={'text-sm font-semibold text-[#F15836]'}>Lấy link</span>
                </ButtonGradient>
                <ButtonCustom
                  label={'Giữ số'}
                  onClick={() => {
                    if (userLogin?.statusVerify === 1) {
                      mutationLockSim.mutate({
                        ssid: 0,
                        listMsisdn: [get(infoData, 'msisdn')],
                      });
                      return;
                    }
                    setIsShowNotification(true);
                  }}
                  disabled={mutationLockSim.isLoading || mutationSendBooking.isLoading}
                  className={'h-[30px] w-[100px] !rounded-l-[10px] !text-sm !font-semibold'}
                />
              </div>
            </div> */}
            {mutationLockSim.isLoading || mutationSendBooking.isLoading ? <SpinCustom /> : null}
            {isLoading ? (
              <SpinCustom />
            ) : (
              <div className={'mt-4 grid h-full w-full grid-cols-1 gap-2'}>
                <span className={'w-full text-base font-bold text-[#404040]'}>Thông tin thuê bao</span>
                <div className={'h-full rounded-[15px]'}>
                  <div
                    role={'list'}
                    className={
                      'rounded-[15px] border border-[#E5E7EB]/60 p-4 shadow-base odd:bg-white even:bg-[#F8F8F8]'
                    }
                  >
                    <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                      <label className={'text-sm font-extrabold text-baseColor'}>Số thuê bao</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'msisdn') || simDetail?.msisdn || "-"}
                      </label>
                    </div>
                    <div
                      className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'}
                    >
                      <label className={'text-sm font-extrabold text-baseColor'}>Loại thuê bao</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'msisdnType') || simDetail?.typeStr || "-"}
                      </label>
                    </div>
                    <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                      <label className={'text-sm font-extrabold text-baseColor'}>Loại số</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'groupName') || simDetail?.groupName || "-"}
                      </label>
                    </div>
                    <div
                      className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'}
                    >
                      <label className={'text-sm font-extrabold text-baseColor'}>Nhà mạng</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'supplier') || simDetail?.supplierStr || "-"}
                      </label>
                    </div>
                    <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                      <label className={'text-sm font-extrabold text-baseColor'}>Phí hoà mạng</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {numbersWithDots(get(infoData, 'roamingFee')?.toLocaleString('vi') || simDetail?.roamingFee || 0)}đ
                      </label>
                    </div>
                    <div
                      className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'}
                    >
                      <label className={'text-sm font-extrabold text-baseColor'}>Hoa hồng</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {numbersWithDots(get(infoData, 'shareValue')?.toLocaleString('vi') || simDetail?.shareValue || 0)}đ
                      </label>
                    </div>
                    <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                      <label className={'text-sm font-extrabold text-baseColor'}>Cước thuê bao</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'monthFee', '-')}
                      </label>
                    </div>
                    <div
                      className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] bg-[#F8F8F8] px-6 py-3'}
                    >
                      <label className={'text-sm font-extrabold text-baseColor'}>Cước cam kết</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'minPrice')?.toLocaleString('vi') || simDetail?.minPrice || 0}đ/tháng
                      </label>
                    </div>
                    <div className={'grid grid-cols-2 space-x-2 rounded-t-[15px] rounded-bl-[15px] px-6 py-3'}>
                      <label className={'text-sm font-extrabold text-baseColor'}>Thời gian cam kết</label>
                      <label className={'text-end text-sm font-medium text-baseColor'}>
                        {get(infoData, 'msisdnTimeCK', '-')}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <Scrollbars className={'h-full w-full'}>
            <div className={'mr-7'}>
              <div
                className={
                  'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white px-6 py-3'
                }
              >
                <div className={'flex flex-row items-center'}>
                  {getIconCategory('SIMSO')}
                  <span className={'ml-2 text-base font-bold text-baseColor'}>
                    Số thuê bao {get(infoData, 'msisdn') || simDetail?.msisdn}
                  </span>
                </div>
                <div className={'space-t-0.5 flex flex-col items-center justify-center md:flex-row md:space-x-2.5'}>
                  <ButtonGradient
                    className={'h-[30px] w-[100px]'}
                    background={'bg-white'}
                    onClick={() => {
                      if (userLogin?.statusVerify === 1) {
                        navigator?.clipboard?.writeText(simDetail?.link);
                        toast.success('Sao chép link thành công!');
                        return;
                      }
                      setIsShowNotification(true);
                    }}
                    // onClick={() => setShowDialog(true)}
                  >
                    <span className={'text-sm font-semibold text-[#F15836]'}>Lấy link</span>
                  </ButtonGradient>
                  <button
                    className={
                      'h-[30px] w-[100px] !rounded-l-[10px] rounded-t-[8px] rounded-bl-[8px] bg-[#F15836] !text-sm text-[12px] !font-semibold text-white'
                    }
                    disabled={mutationLockSim.isLoading || mutationSendBooking.isLoading}
                    // onClick={() => {
                    //   if (userLogin?.statusVerify === 1) {
                    //     mutationLockSim.mutate({
                    //       ssid: 0,
                    //       listMsisdn: [get(infoData, 'msisdn')],
                    //     });
                    //     return;
                    //   }
                    //   setIsShowNotification(true);
                    // }}
                    onClick={() => setShowDialog(true)}
                  >
                    Giữ số
                  </button>
                </div>
              </div>
              {mutationLockSim.isLoading || mutationSendBooking.isLoading ? <SpinCustom /> : null}
              {isLoading ? (
                <SpinCustom />
              ) : (
                <div className={'mt-6 grid h-fit w-full grid-cols-1 gap-4 md:grid-cols-3'}>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Số thuê bao</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>{get(infoData, 'msisdn') || simDetail?.msisdn}</span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Loại thuê bao</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>{get(infoData, 'msisdnType') || simDetail?.typeStr || "-"}</span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Loại số</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>{get(infoData, 'groupName') || simDetail?.groupName || "-"}</span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Nhà mạng</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>{get(infoData, 'supplier') || simDetail?.supplierStr || "-"}</span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Phí hoà mạng</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>
                      {numbersWithDots(get(infoData, 'roamingFee')?.toLocaleString('vi') || simDetail?.roamingFee || 0)}đ
                    </span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Hoa hồng</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>
                      {numbersWithDots(get(infoData, 'shareValue')?.toLocaleString('vi') || simDetail?.shareValue || 0)}đ
                    </span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1 min-h-[13px] min-w-[13px]'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Cước thuê bao</span>
                    </div>
                    <span className={'text-right text-base font-medium text-baseColor'}>
                      {get(infoData, 'monthFee', '-')}
                    </span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Cước cam kết</span>
                    </div>
                    <span className={'text-base font-medium text-baseColor'}>
                      {get(infoData, 'minPrice', 0).toLocaleString('vi') || simDetail?.minPrice || 0}đ/tháng
                    </span>
                  </div>
                  <div
                    className={
                      'flex flex-row items-center justify-between rounded-t-[15px] rounded-bl-[15px] bg-white p-6'
                    }
                  >
                    <div className={'flex flex-row items-center'}>
                      <svg
                        className={'-mt-1 min-h-[13px] min-w-[13px]'}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="6.14253" cy="6.74995" r="6.04878" fill="#F15836" />
                      </svg>
                      <span className={'ml-1 text-base font-bold text-baseColor'}>Thời gian cam kết</span>
                    </div>
                    <span className={'text-right text-base font-medium text-baseColor'}>
                      {get(infoData, 'msisdnTimeCK', '-')}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </Scrollbars>
        )}
      </div>
      <Transition show={showDialog} as={Fragment}>
        <Dialog
          open={showDialog}
          onClose={() => { }}
          className="fixed inset-0 z-50 flex h-full min-h-screen w-screen flex-row items-center justify-center overflow-y-auto bg-[#000000]/60"
        >
          <Dialog.Panel
            className={
              'h-[400px] min-h-[400px] w-[400px] rounded-t-[16px] rounded-bl-[16px] border border-gray-200' +
              ' bg-[#F8F8F8] shadow-base'
            }
          >
            <Dialog.Title className={'mb-2 flex h-fit flex-col items-start px-6 pt-6'}>
              <div className={'flex h-fit w-full flex-row justify-end'}>
                <button type={'button'} onClick={() => setShowDialog(false)}>
                  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_573_26413)">
                      <path
                        d="M0.314708 0.701427C0.414214 0.601669 0.532424 0.522521 0.662566 0.468518C0.792707 0.414515 0.932225 0.386719 1.07313 0.386719C1.21403 0.386719 1.35354 0.414515 1.48369 0.468518C1.61383 0.522521 1.73204 0.601669 1.83154 0.701427L7.5004 6.37242L13.1692 0.701427C13.2688 0.60183 13.3871 0.522825 13.5172 0.468924C13.6473 0.415022 13.7868 0.38728 13.9277 0.38728C14.0685 0.38728 14.208 0.415022 14.3381 0.468924C14.4682 0.522825 14.5865 0.60183 14.6861 0.701427C14.7857 0.801024 14.8647 0.919262 14.9186 1.04939C14.9725 1.17952 15.0002 1.31899 15.0002 1.45984C15.0002 1.6007 14.9725 1.74017 14.9186 1.8703C14.8647 2.00043 14.7857 2.11867 14.6861 2.21826L9.01509 7.88711L14.6861 13.556C14.7857 13.6556 14.8647 13.7738 14.9186 13.9039C14.9725 14.0341 15.0002 14.1735 15.0002 14.3144C15.0002 14.4552 14.9725 14.5947 14.9186 14.7248C14.8647 14.855 14.7857 14.9732 14.6861 15.0728C14.5865 15.1724 14.4682 15.2514 14.3381 15.3053C14.208 15.3592 14.0685 15.3869 13.9277 15.3869C13.7868 15.3869 13.6473 15.3592 13.5172 15.3053C13.3871 15.2514 13.2688 15.1724 13.1692 15.0728L7.5004 9.40181L1.83154 15.0728C1.73195 15.1724 1.61371 15.2514 1.48358 15.3053C1.35345 15.3592 1.21398 15.3869 1.07313 15.3869C0.932275 15.3869 0.792802 15.3592 0.662673 15.3053C0.532543 15.2514 0.414305 15.1724 0.314708 15.0728C0.215111 14.9732 0.136106 14.855 0.0822051 14.7248C0.0283036 14.5947 0.000560851 14.4552 0.000560851 14.3144C0.000560851 14.1735 0.0283036 14.0341 0.0822051 13.9039C0.136106 13.7738 0.215111 13.6556 0.314708 13.556L5.9857 7.88711L0.314708 2.21826C0.21495 2.11876 0.135802 2.00055 0.0817995 1.87041C0.0277966 1.74026 0 1.60075 0 1.45984C0 1.31894 0.0277966 1.17943 0.0817995 1.04928C0.135802 0.919142 0.21495 0.800933 0.314708 0.701427Z"
                        fill="#A9A9A9"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_573_26413">
                        <rect width="15" height="15" fill="white" transform="translate(0 0.386719)" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
              <div className={'m-4 flex h-fit w-full flex-1 items-center justify-center'}>
                <img src={ComingSoonIcon} alt="image1" className="text-center" />
              </div>
            </Dialog.Title>
            <Dialog.Description className={'flex h-full w-full flex-col items-center px-6 pb-6'}>
              <h2 className={'mb-4 text-[22px] font-extrabold leading-[26px] text-baseColor'}>Thông báo</h2>
              <p className={'text-center text-sm font-medium text-[#818181]'}>Vui lòng tải ứng dụng Shop360 để có thể kinh doanh sản phẩm dễ dàng hơn!</p>
              <div
                className={
                  'h-[40px] w-full rounded-t-[8px] rounded-bl-[8px] bg-gradient-to-r from-[#F15836]' +
                  ' mt-6 to-[#FF924F] p-[2px]'
                }
              >
                <button
                  className={'h-full w-full rounded-t-[6px] rounded-bl-[6px]'}
                  onClick={redirectDownload}
                >
                  <span className={'text-sm font-extrabold text-white'}>Tải ứng dụng</span>
                </button>
              </div>
            </Dialog.Description>
          </Dialog.Panel>
        </Dialog>
      </Transition>
      {isShowNotification && <AccountAuthen setIsShowNotification={setIsShowNotification} />}
    </div>
  );
};
